import { GetRequest, PostRequest } from "../../service"

const ControllerName = "PatientMedicalAttachment"

export const GetPatientMedicalAttachments = (patientId, spText) =>
    GetRequest(`${ControllerName}/${patientId}${spText}`)

export const GetPatientAttachmentsTypes = () =>
    GetRequest(`${ControllerName}/lookup/attachment-types`)


export const UploadPatientMedicalAttachment = (data) =>
    PostRequest(`${ControllerName}`, data)
